const state = {
  options: {},
  search: '',
}

const mutations = {
  SET_OPTIONS: (state, data) => {
    state.options = data
  },
  SET_SEARCH: (state, data) => {
    state.search = data
  }
}

const actions = {
  setOptions({ commit }, payload) {
    commit('SET_OPTIONS', payload)
  },
  setSearch({ commit }, payload) {
    commit('SET_SEARCH', payload)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
